/* src/app/system-utils/custom-tree-view/custom-tree-view.component.scss */
* {
  box-sizing: border-box;
}
.system-main__apps {
  padding: 4px;
  font-size: 80%;
  border-radius: 3px;
  transition: all 0.3s ease;
  backface-visibility: hidden;
  min-width: 300px;
}
.system-main__apps:hover {
  background: #ccfcf3;
  cursor: pointer;
}
.system-main__icon {
  margin-right: 10px;
  margin-left: 20px;
}
.system-main__close {
  float: right;
  margin-top: -6px;
  font-size: 10px;
}
.system-main__expands {
  float: right;
  margin-top: 5px;
}
.tree-view {
  list-style-type: none;
  transition: all 0.3s ease-in-out;
  padding-inline-start: 4px;
}
/*# sourceMappingURL=custom-tree-view.component.css.map */
